import { clsx } from "clsx";
import { useInfiniteScroll } from "../../hooks/useInfiniteScroll";
import { useTranslations } from "../../i18n";
import { Skeleton } from "../Skeleton";
import { Spinner } from "../Spinner";
import { Text } from "../Text";
import { ComboBoxItem } from "./ComboBoxItem";
import { useComboBoxContext } from "./context";

export const ComboBoxContent = () => {
  const { t } = useTranslations();
  const {
    filteredOptions,
    contentClassName,
    maxHeight,
    loading,
    loadingMore,
    onLoad,
  } = useComboBoxContext();

  const { containerRef } = useInfiniteScroll({
    onLoad,
    enabled: !loading && !loadingMore && !!onLoad,
  });

  return (
    <div
      ref={containerRef}
      className={clsx("nuco-combobox__content", contentClassName)}
      style={{ maxHeight }}
      role="presentation"
    >
      {loading ? (
        <div className="nuco-combobox__content-loadingState">
          <Skeleton width="100%" height="2.125rem" />
          <Skeleton width="100%" height="2.125rem" />
          <Skeleton width="100%" height="2.125rem" />
        </div>
      ) : (
        <>
          {filteredOptions.map((option, index) => (
            <ComboBoxItem key={option.id} option={option} index={index} />
          ))}

          {filteredOptions.length === 0 && (
            <div className="nuco-combobox__content-emptyState">
              <Text>{t("ui.comboBox.noResults")}</Text>
            </div>
          )}

          {filteredOptions.length > 0 && onLoad && loadingMore && (
            <div className="nuco-combobox__content-loadingMoreState">
              <Spinner size="sm" color="brand" />
            </div>
          )}
        </>
      )}
    </div>
  );
};
